import { API } from 'src/definitions';
import regexps from 'src/schemas/regexps';
import Schema from 'validate';

export default new Schema<API.Consumers.UpdateConsumer.Request>(
  {
    email: {
      required: false,
      type: 'string',
      match: regexps.emailOrEmpty,
      message: {
        required: 'A valid email is required',
        match: 'A valid email is required'
      }
    },
    firstName: {
      required: false,
      message: {
        required: 'First name is required'
      }
    },
    lastName: {
      required: false,
      message: {
        required: 'Last name is required'
      }
    },
    organisation: {
      required: false,
      type: 'string'
    },
    stepId: {
      required: false,
      type: 'string'
    },
    personaId: {
      required: false,
      type: 'string'
    }
  },
  { strip: false }
);
